import type { ReactNode } from 'react';

export interface LayoutProps {
  alternateColor?: boolean;
  children?: ReactNode;
  fullPage?: boolean;
  loading?: boolean;
  horizontalAlign?: 'left' | 'center' | 'right';
  verticalAlign?: 'top' | 'center' | 'bottom';
  fixed?: boolean;
}

export enum LAYOUT_CONST {
  TEST_ID = 'layout',
}
